module.exports = __webpack_public_path__ + "static/MISSION10000_BIOECONOMY_Conference Proceedings-b4930a9b78c3f9c68270942f5e86fffb.pdf";